module.exports = __webpack_public_path__ + "static/index/img/home-restaurants.e1fda21e.jpg";